// Headline generation logic using OpenAI API via backend
import api from '../../../services/api';

export const generateHeadlines = async (formData) => {
  try {
    const response = await api.post('/api/generate-headlines', {
      role: formData.role,
      industry: formData.industry,
      targetAudience: formData.targetAudience || '',
      strengths: formData.strengths || '',
      achievements: formData.achievements || '',
      keywords: formData.keywords || '',
      goal: formData.goal,
      tone: formData.tone,
    });

    return {
      headlines: response.data.headlines,
    };
  } catch (error) {
    console.error('Error generating headlines:', error);
    
    // Handle specific error codes
    if (error.response?.status === 401) {
      throw new Error('AUTH_REQUIRED');
    }
    if (error.response?.status === 402) {
      throw new Error('INSUFFICIENT_CREDITS');
    }
    
    throw new Error(
      error.response?.data?.detail || 'Failed to generate headlines. Please try again.'
    );
  }
};
